import axios from 'axios';

const marketplaceApi = axios.create({
  baseURL: 'https://apiemiride.socialpartners.in/market-place/api/dealer-portal',
  headers: { 'Content-Type': 'application/json' },
});

marketplaceApi.interceptors.request.use((config) => {
  const token     = localStorage.getItem('token');
  const companyId = localStorage.getItem('company_id');
  if (token)     config.headers['Authorization']  = `Bearer ${token}`;
  if (companyId) config.headers['x-company-id']   = companyId;
  return config;
});

export default marketplaceApi;
